import styled from "styled-components/macro";
import { NavLink } from "react-router-dom";

export default styled(NavLink)`
  padding: 15px;
  padding-left: 25px;
  display: block;
  text-decoration: none;
  color: ${(props) => props.theme.colors.colorGrayDark};

  :hover {
    background-color: ${(props) => props.theme.colors.pastelLilac};
    color: ${(props) => props.theme.colors.primary};
  }
`;
